import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable()
export class ResourceConfig {
  public readonly BASE_API_URL = environment.API_URL;
}
